import type { HateoasLink } from "../../utils/hateoas-link";

export enum PartyAuthenticationSessionStatus {
  PENDING = "PENDING",
  STARTED = "STARTED",
  DONE = "DONE",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  REFUSED = "REFUSED",
  EXPIRED = "EXPIRED",
}

export enum PartyIdentifierType {
  PHONE_NUMBER = "PHONE_NUMBER",
  IDENTITY_ID = "IDENTITY_ID",
  TRUSTED_DEVICE = "TRUSTED_DEVICE",
  CREATE_RECIPIENT = "CREATE_RECIPIENT",
  LOGIN = "LOGIN",
  CARD_ID = "CARD_ID",
}

export interface PartyIdentifier {
  value: string;
  type: PartyIdentifierType;
}

export interface IdentityIdentifier {
  value: string;
  type: string;
}

export interface ExternalIdentifier {
  value: string;
  type: string;
}

export interface PartyAuthenticationSessionLinks {
  self?: HateoasLink;
  authenticationSessionCancel?: HateoasLink;
  authenticationSessionSendSMSOTP?: HateoasLink;
  authenticationSessionVerifySMSOTP?: HateoasLink;
  authenticationSessionVerifyPincode?: HateoasLink;
  authenticationSessionVerifyTrustedDevice?: HateoasLink;
}

export interface PartyAuthenticationSession {
  id: string;
  token: string;
  initiatedAt: Date;
  expiredAt: Date;
  status: PartyAuthenticationSessionStatus;
  identityIdentifier: PartyIdentifier;
  externalIdentifier?: ExternalIdentifier;
  data?: any;
  identityId?: string;
  links: PartyAuthenticationSessionLinks;
  isSuspicious: boolean;
  suspiciousComment?: string;
}
